import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import api, { apiAction, apiActionWithRoute } from '../../../api'
import toPlural from '../../../common/formatters/plural'
import capitalize from '../../../common/formatters/capitalize'
import getActions from './actions'

import { Button, Loading }  from '../../../components'

import Item from './item'
import S from './styled'

const defaultItem = { displayName: {} }

const UnitsEditor = props => {
  const {
    fetchLocales, locales, localesLoading,
    fetchItems, items,
    noDescription,
    withImage,
    textArea,
  } = props

  useEffect(() => {
    (async () => {
      await fetchLocales()
      await fetchItems()
    })()
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  const [showNew, setShowNew] = useState(true)

  const { onAdd, onDelete, onSave } = getActions({ ...props, setShowNew })

  const onCancelNew = () => setShowNew(true)

  return localesLoading ? <Loading overlay/> : locales && locales.length ? (
    <div>
      <S.List>
        {items.map((item, index) => (
          <Item {...{ item, key: item.id, locales, onDelete, noDescription, onSave, withImage, textArea }} />
        ))}
      </S.List>
      {showNew ?  (
        <Button blue onClick={() => setShowNew(false)} > Add </Button>
      ) : (
        <Item {...{
          item: defaultItem, locales, noDescription, onSave: onAdd, isNew: true, onCancelNew, withImage, textArea,
        }} />
      )}
    </div>
  ) : <div>Please create at least one locale first</div>
}

UnitsEditor.propTypes = {
  locales: PropTypes.array,
  localesLoading: PropTypes.bool,
  fetchLocales: PropTypes.func,
  items: PropTypes.array,
}

UnitsEditor.defaultProps = {
  entityLabel: 'Unit',
  entityName: 'unit',
}

const mapStateToProps = (state, { entityName = 'unit' }) => ({
  locales: state.locales.list,
  localesLoading: state.locales.isLoading,
  items: state[toPlural(entityName)].list,
})

const mapDispatchToProps = (dispatch, { entityName = 'unit' } ) => ({
  fetchLocales: () => dispatch(apiAction(api.getLocales)()),
  fetchItems: () => dispatch(apiAction(api[`get${capitalize(entityName)}s`])()),
  addItem: item => dispatch(apiAction(api[`add${capitalize(entityName)}`])(item)),
  deleteItem: entityId => dispatch(apiActionWithRoute(api[`delete${capitalize(entityName)}`])(entityId)()),
  updateItem: (entityId, item) => dispatch(apiActionWithRoute(api[`update${capitalize(entityName)}`])(entityId)(item)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UnitsEditor)
